/**
 * A identidade de um objeto do change set (S-072, F0).
 *
 * ⚠️ **Nome sozinho não identifica objeto ABAP.** A convenção RAP batiza a behavior
 * definition com o nome da view raiz, então `ZI_PEDIDO` existe como `DDLS` e como `BDEF`
 * no mesmo change set. A migration 0090 já tinha corrigido a chave no banco; a interface
 * continuava passando só o nome, e por isso resolvia manifesto, disposição e destaque de
 * linha para o artefato errado.
 *
 * Módulo folha de propósito: ele é importado pela matriz, pela tela e pelo inspetor, e
 * nenhum deles deve importar o outro só para comparar duas strings.
 */
export interface CcObjectRef {
  name: string;
  type: string;
}

/** Se os dois se referem ao mesmo objeto. `null` de qualquer lado é "não". */
export function sameObject(
  a: CcObjectRef | null | undefined,
  b: CcObjectRef | null | undefined,
): boolean {
  return !!a && !!b && a.name === b.name && a.type === b.type;
}

/** O ref de uma linha vinda do servidor, que traz nome e tipo em campos separados. */
export function refOf(row: { object_name: string; object_type: string }): CcObjectRef {
  return { name: row.object_name, type: row.object_type };
}
